import {
  Limit as LimitAPI,
  GlobalActivation as GlobalActivationAPI,
  GlobalAwardCount as GlobalAwardCountAPI,
  MembershipActivation as MembershipActivationAPI,
  MembershipAwardCount as MembershipAwardCountAPI,
} from '@occc-app/Activate/apiTypes';

import { Limits as LimitsClient, LimitKeys, GlobalLimit, MembershipLimit } from './types';

type DeserializeLimitType = (limitType: LimitAPI['attributes']['limit_type']) => LimitKeys;
export const deserializeLimitType: DeserializeLimitType = (limitType) => {
  switch (limitType) {
    case 'global_activation':
      return 'globalLimit';
    case 'global_award_count':
      return 'globalLimit';
    case 'membership_activation':
      return 'membershipLimit';
    case 'membership_award_count':
      return 'membershipLimit';
    default:
      throw new Error('Unsupported limitType');
  }
};

type DeserializeGlobalAwardCount = (
  limitBody: GlobalActivationAPI | GlobalAwardCountAPI,
) => GlobalLimit;
const deserializeGlobalAwardCount: DeserializeGlobalAwardCount = (limitBody) => ({
  type: 'globalLimit',
  active: true,
  limit: limitBody.configuration.limit,
});

type DeserializeMembershipAwardCount = (
  limitBody: MembershipActivationAPI | MembershipAwardCountAPI,
) => MembershipLimit;
const deserializeMembershipAwardCount: DeserializeMembershipAwardCount = (limitBody) => ({
  type: 'membershipLimit',
  active: true,
  limit: limitBody.configuration.limit,
});

type DeserializeLimit = (limitBody: LimitAPI) => LimitsClient;
export const deserializeLimit: DeserializeLimit = (limitBody) => {
  switch (limitBody.attributes.limit_type) {
    case 'global_activation':
      return deserializeGlobalAwardCount(limitBody.attributes);
    case 'global_award_count':
      return deserializeGlobalAwardCount(limitBody.attributes);
    case 'membership_activation':
      return deserializeMembershipAwardCount(limitBody.attributes);
    case 'membership_award_count':
      return deserializeMembershipAwardCount(limitBody.attributes);
    default:
      throw new Error('Unsupported limit_type');
  }
};
